import PropTypes from 'prop-types';
import React from 'react';
import includeScript from './includeScript.js';
import window from './globalWrappers/window.js';

const recaptchaCallback = "recaptchaCallback";

class Captcha extends React.Component {

  componentDidMount() {
    let {
      jsSrc,
      callback
    } = this.props;

    if (callback) {
      window[recaptchaCallback] = callback;
    }

    includeScript(jsSrc);
  }

  render() {
    let {
      siteKey,
      callback
    } = this.props;

    return (
      <div
        className="g-recaptcha"
        data-size="invisible"
        data-sitekey={siteKey}
        data-callback={callback ? recaptchaCallback : undefined}
      />
    );
  }
}

Captcha.propTypes = {
  jsSrc: PropTypes.string,
  siteKey: PropTypes.string,
  callback: PropTypes.func
};

Captcha.defaultProps = {
  jsSrc: "https://www.google.com/recaptcha/api.js"
};

export default Captcha;
